const AUTH_URL = process.env.REACT_APP_AUTH_URL;

export default AUTH_URL;
